// global
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
// local
import styles from './SnackbarList.module.scss';
import Snackbar from './Snackbar';
// actions
import { dismissSnackbar, dismissLast } from 'app/redux/actions/snackbar.action';

const DURATION = 400; // 400 ms
const SNACKBAR_TIMEOUT = 5000; // 5 seg

function SnackbarList(props) {
  const [timeOut, setTimeOut] = useState(null);

  const { messages } = props.snackbar;

  const startTimeOut = () => {
    setTimeOut(setTimeout(() => dismissLastSnackbar(), SNACKBAR_TIMEOUT));
  };

  const clearTimeOut = () => {
    if (timeOut) {
      clearTimeout(timeOut);
    }
  };

  const dismissLastSnackbar = () => props.dispatch(dismissLast());

  const handleDismissSnackbar = id => () => props.dispatch(dismissSnackbar(id));

  useEffect(() => {
    const { messages } = props.snackbar;
    clearTimeOut();
    // if there is a message to be displayed
    if (messages.length > 0) {
      startTimeOut();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.snackbar.messages]);

  return (
    <TransitionGroup className={styles.snackbarList}>
      {messages.map(message => {
        return (
          <CSSTransition key={message.id} timeout={DURATION} classNames={styles.snackbar}>
            <Snackbar
              id={message.id}
              title={message.title}
              canClose={message.action}
              handleDismissSnackbar={handleDismissSnackbar}
            />
          </CSSTransition>
        );
      })}
    </TransitionGroup>
  );
}

SnackbarList.propTypes = {
  dispatch: PropTypes.func,
  snackbar: PropTypes.object
};

const mapStateToProps = state => ({
  snackbar: state.snackbar
});
export default connect(mapStateToProps)(SnackbarList);
